import React, { useState, useEffect, useCallback } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import Cropper from 'react-easy-crop';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

//hooks
import useFetchImages from '../../Hooks/useFetchImages';
import useUploadImage from '../../Hooks/useUploadImage';
import useDeleteImage from '../../Hooks/useDeleteImage';

// styles
import './QuoteCreator.css';

// custom components
import QuotePartTwo from '../../Components/QuotePartTwo/QuotePartTwo';

//utilities
import { displayDate } from '../../Utils/dateFormatUtils';
import getCroppedImg from '../../Utils/cropImage';

//npm components
import { Img } from 'react-image';

//carbon components
import {
	Icon,
	Button,
	TextInput,
	DatePicker,
	DatePickerInput,
	FormItem,
	Table,
	TableHead,
	TableHeader,
	TableBody,
	TableRow,
	TableCell,
	OverflowMenu,
	OverflowMenuItem,
	Modal,
	Loading,
	Slider,
	ToastNotification,
} from 'carbon-components-react';
import { settings } from 'carbon-components';

import { TrashCan20, Undo20, Add32, RotateClockwise20, ArrowRight20, ZoomIn20, Crop20 } from '@carbon/icons-react';

const { prefix } = settings;

// COMPONENT FUNCTION
function QuoteCreator(props) {
	//set history
	const history = useHistory();

	// console.log("PROPPI", props);
	const token = props.token;
	const user = props.user;

	//set state
	const [refresh, setRefresh] = useState(false);
	const [currentQuote, setCurrentQuote] = useState([]);
	const [addFlipItemOpen, setAddFlipItemOpen] = useState(false);
	const [files, setFiles] = useState([]);
	const [step2, setStep2] = useState(0);
	const [newFlip, setNewFlip] = useState({
		thumbnails: true,
		itemNumber: '',
		upc: '',
		description: '',
		units: '',
		packSize: '',
		listPrice: '',
		paidFor: '',
		expireDate: '',
		estimatedShipDate: '',
		actions: true,
	});
	const [editItemOpen, setEditItemOpen] = useState(false);
	const [itemEdit, setItemEdit] = useState({});
	const [imagesModalOpen, setImagesModalOpen] = useState(false);
	const [imagesModalUpc, setImagesModalUpc] = useState(null);
	const [contactInfo, setContactInfo] = useState({
		from: {},
		to: {},
	});
	const [cropModalOpen, setCropModalOpen] = useState(false);
	const [imageToCrop, setImageToCrop] = useState('');
	const [crop, setCrop] = useState({ x: 0, y: 0 });
	const [rotation, setRotation] = useState(0);
	const [zoom, setZoom] = useState(1);
	const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
	const [croppedImage, setCroppedImage] = useState(null);
	const [notification, setNotification] = useState(false);
	const [notificationContent, setNotificationContent] = useState({
		title: '',
		caption: '',
		type: 'info',
	});

	// custom hooks
	const { errorImg, loadingImages, images, fetchImgData } = useFetchImages(token);
	const { errorUploadImg, loadingUploadImage, imageToUpload, uploadImage } = useUploadImage(token);
	const { errorDeleteImg, loadingDeleteImage, imageToDelete, deleteImage } = useDeleteImage(token);

	const uid = () => {
		const newUid = uuidv4();
		// console.log("uid created", newUid);
		return newUid;
	};

	//componentdid??
	useEffect(() => {
		// console.log("DATA RECEIVED", props.quoteItems); //DEBUG
		// console.log("MOCK DATA", mockData);

		if (props.quoteItems) {
			const formattedQuoteItems = props.quoteItems.map((item, itemIndex) => {
				let quoteItemObj = {};

				//format FOB Cost
				let FOBCost = item.fOBCost;
				if (FOBCost[0] === '.') {
					FOBCost = `0${FOBCost}`;
				}
				console.log('FOB', item.fOBCost[0]);

				quoteItemObj.thumbnails = true;
				quoteItemObj.itemNumber = item.itemNumber;
				quoteItemObj.upc = item.upc.replace(/ /g, '');
				quoteItemObj.description = item.description;
				quoteItemObj.units = item.units;
				quoteItemObj.packSize = item.packSize;
				quoteItemObj.listPrice = FOBCost;
				quoteItemObj.paidFor = item.paidFor;
				quoteItemObj.expireDate = item.expireDate;
				quoteItemObj.estimatedShipDate = item.estimatedShipDate;
				quoteItemObj.actions = true;

				return quoteItemObj;
			});

			setCurrentQuote(formattedQuoteItems);
		}

		return () => {};
	}, []);

	// delete an item
	const _handleDeleteQuoteItem = (deleteIndex) => {
		console.log(deleteIndex);
		console.log('deleting', currentQuote[deleteIndex]);

		let confirmed = window.confirm(`Are you sure you want to delete this item?`);
		if (confirmed === false) return;

		let currentQuoteClone = currentQuote.map((x) => x);
		currentQuoteClone.splice(deleteIndex, 1);
		setCurrentQuote(currentQuoteClone);
	};

	//method that allows user to add a flip item to the quote creator
	const _handleSubmitFlipItems = () => {
		console.log('YAMAN', newFlip);
		let newFlipClone = {};
		newFlipClone = newFlip;

		// processing
		newFlipClone.id = `FLIP${currentQuote.length + 1}`;
		newFlipClone.itemNumber = `${currentQuote.length + 1}`;
		newFlipClone.thumbnails = true;
		newFlipClone.actions = true;
		let flipDate = new Date(newFlipClone.estimatedShipDate);
		newFlipClone.estimatedShipDate = displayDate(flipDate);

		let currentQuoteClone = currentQuote;
		currentQuoteClone.push(newFlipClone);
		setCurrentQuote(currentQuoteClone);
		setAddFlipItemOpen(false);
	};

	const _handleCloseModalOnlyOnCancelBtn = (ev, setModalOpen) => {
		// console.log(ev.target, "1<><><><>");
		// console.log(ev.target.getAttribute('type'), "2<><><><>");
		if (ev.target.getAttribute('type') === 'button' || ev.target.getAttribute('d') || ev.target.getAttribute('aria-label') === 'Close') {
			//actual cancel button is clicked, so close the modal
			setModalOpen(false);
		}
	};

	const _handleMoveUpItem = (quoteItemIndex) => {
		//edge case, trying to move the topmost item up
		if (quoteItemIndex === 0) {
			return;
		}

		let newOrderedArray = currentQuote.map((quoteItem, i) => {
			if (i === quoteItemIndex - 1) {
				return currentQuote[quoteItemIndex];
			} else if (i === quoteItemIndex) {
				return currentQuote[quoteItemIndex - 1];
			} else {
				return quoteItem;
			}
		});

		setCurrentQuote(newOrderedArray);
	};

	const _handleMoveDownItem = (quoteItemIndex) => {
		//edge case, trying to move the downmost item down
		if (quoteItemIndex === currentQuote.length - 1) {
			return;
		}

		let newOrderedArray = currentQuote.map((quoteItem, i) => {
			if (i === quoteItemIndex) {
				return currentQuote[quoteItemIndex + 1];
			} else if (i === quoteItemIndex + 1) {
				return currentQuote[quoteItemIndex];
			} else {
				return quoteItem;
			}
		});

		setCurrentQuote(newOrderedArray);
	};

	// setting edit object and opening modal
	const _handleOpenEditModal = (quoteItemIndex) => {
		console.log('editing', quoteItemIndex, currentQuote[quoteItemIndex]);
		setItemEdit(currentQuote[quoteItemIndex]);
		setEditItemOpen(true);
	};

	// method to finalize edits to an item
	const _handleEditItem = () => {
		console.log('finalize edits to', itemEdit);
		let itemEditClone = { ...itemEdit };
		let currentQuoteClone = [];
		let theIndex;
		currentQuoteClone = currentQuote.map((quoteItem, i) => {
			if (quoteItem.itemNumber === itemEdit.itemNumber) {
				theIndex = i;
			}
			return quoteItem;
		});
		console.log('EDIT ITEM', currentQuote[theIndex]);
		itemEditClone.id = currentQuote[theIndex].id;
		itemEditClone.actions = true;
		currentQuoteClone.splice(theIndex, 1, itemEditClone);
		// currentQuoteClone.push(itemEditClone)
		setCurrentQuote(currentQuoteClone);
		setEditItemOpen(false);
	};

	//method that allows user to go back to the previous screen
	const _handleAddMoreInventory = () => {
		history.push('/?mode=add');
	};

	//method that allows you to manage the images for that product
	const _handleOpenImagesModal = (quoteItemIndex) => {
		console.log('editing images of', quoteItemIndex, 'UPC:', currentQuote[quoteItemIndex].upc);
		fetchImgData(currentQuote[quoteItemIndex].upc);
		setImagesModalUpc(currentQuote[quoteItemIndex].upc);
		// setImagesEdit(currentQuote[quoteItemIndex])
		setImagesModalOpen(true);
	};

	//method to handle the image upload
	const _handleImgUpload = (e) => {
		console.log(e);
		console.log(e.target.files[0]);
		console.log('-------------');
		const theImage = [e.target.files[0]];
		console.log('SAVING', theImage, 'in', imagesModalUpc);
		uploadImage(theImage, imagesModalUpc, fetchImgData);
		// check for error
		if (errorImg) {
			setNotification(true);
			setNotificationContent({
				title: 'Error',
				caption: 'Error uploading image.',
				type: 'error',
			});
			setTimeout(() => {
				setNotification(false);
			}, 3000);
		} else {
			setNotification(true);
			setNotificationContent({
				title: 'Success',
				caption: 'Image succesfully uploaded.',
				type: 'success',
			});
			setTimeout(() => {
				setNotification(false);
			}, 3000);
		}
	};

	//method to handle the image upload
	const _handleImgDelete = (imgKey) => {
		console.log(imgKey);
		const imgName = imgKey.split('/')[1];
		console.log('-------------');
		console.log('DELETING', imgName, 'of', imagesModalUpc);

		let confirmed = window.confirm(`Are you sure you want to delete this image?`);
		if (confirmed === false) return;

		deleteImage(imgName, imagesModalUpc, fetchImgData);

		if (errorDeleteImg) {
			setNotification(true);
			setNotificationContent({
				title: 'Error',
				caption: 'Error deleting image.',
				type: 'error',
			});
			setTimeout(() => {
				setNotification(false);
			}, 3000);
		} else {
			setNotification(true);
			setNotificationContent({
				title: 'Success',
				caption: 'Image succesfully deleted.',
				type: 'success',
			});
			setTimeout(() => {
				setNotification(false);
			}, 3000);
		}
	};

	// method to handle resize
	const _handleImgResize = (e, imgKey) => {
		e.preventDefault();
		const imgUrl = `https://cwc-product-images-s3-bucket.s3.amazonaws.com/${imgKey}`;
		setImageToCrop(imgUrl);
		setRotation(0);
		setZoom(1);
		setCropModalOpen(true);
		return;
	};

	// image manipulation functions (cropping zooming rotating saving)

	const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
		setCroppedAreaPixels(croppedAreaPixels);
	}, []);

	const showCroppedImage = useCallback(async () => {
		try {
			const croppedImage = await getCroppedImg(imageToCrop, croppedAreaPixels, rotation);
			// console.log('done cropping', { croppedImage })
			setCroppedImage(croppedImage);

			uploadImage([croppedImage], imagesModalUpc, fetchImgData);
			setTimeout(() => {
				setCropModalOpen(false);
				setImageToCrop('');
			}, 500);

			if (errorImg) {
				setNotification(true);
				setNotificationContent({
					title: 'Error',
					caption: 'Error cropping image.',
					type: 'error',
				});
				setTimeout(() => {
					setNotification(false);
				}, 3000);
			} else {
				setNotification(true);
				setNotificationContent({
					title: 'Success',
					caption: 'Image succesfully cropped.',
					type: 'success',
				});
				setTimeout(() => {
					setNotification(false);
				}, 3000);
			}
		} catch (e) {
			console.error(e);
		}
	}, [croppedAreaPixels, rotation]);

	//handle setting the step 2
	const _handleSettingStep2 = () => {
		if (currentQuote.length === 0) {
			alert('At least one item is required to create a quote.');
			return;
		}
		setStep2(1);
	};

	// Inventory items selected
	const headers = [
		{
			key: 'thumbnails',
			header: ' ',
		},
		{
			key: 'itemNumber',
			header: 'Item Number',
		},
		{
			key: 'upc',
			header: 'UPC',
		},
		{
			key: 'description',
			header: 'Description',
		},
		{
			key: 'units',
			header: 'Units',
		},
		{
			key: 'packSize',
			header: 'Packet Size',
		},
		{
			key: 'listPrice',
			header: 'Price',
		},
		{
			key: 'paidFor',
			header: 'Status',
		},
		{
			key: 'expireDate',
			header: 'Expiration Date',
		},
		{
			key: 'estimatedShipDate',
			header: 'Est. Ship Date',
		},
		{
			key: 'actions',
			header: 'Actions',
		},
	];

	const renderImgModalContent = () => {
		if (loadingImages || !images) {
			return (
				<div id="ImagesItemModalLoadingCont">
					<Loading active={true} id="loadingImagesSpinner" withOverlay={false} />
				</div>
			);
		}

		const imageLinks = images.map((img, i) => {
			let imageKey = `${img.Key}?${Math.random()}`;

			return (
				<div className={'singleImgContainer'} key={i}>
					<Zoom zoomMargin={40}>
						<img key={imageKey} src={`https://cwc-product-images-s3-bucket.s3.amazonaws.com/${imageKey}`} className={'imageModalImages'} />
					</Zoom>
					<div className={'imgActionBtns'}>
						<a className={'imgDeleteBtn'} onClick={() => _handleImgDelete(img.Key)} href="#">
							<TrashCan20 />
						</a>
						<a className={'imgCropBtn'} onClick={(e) => _handleImgResize(e, img.Key)} href="#">
							<Crop20 />
						</a>
					</div>
				</div>
			);
		});

		// console.log(">>>", images); //DEBUG
		// console.log(">>>", images[0]);
		// console.log(">>>", images[0]["Key"]);

		return (
			<div id="ImagesItemModalCont">
				{imageLinks}
				<div id={'addImgBox'}>
					<label htmlFor="imageUploadInput">Add Image</label>

					<input type="file" id="imageUploadInput" name="imageUploadInput" accept="image/*" onChange={(e) => _handleImgUpload(e)} />
				</div>
			</div>
		);
	};

	if (step2 === 1) {
		return (
			<QuotePartTwo
				files={files}
				user={user}
				token={token}
				setStep2={setStep2}
				step2={step2}
				contactInfo={contactInfo}
				setContactInfo={setContactInfo}
				currentQuote={currentQuote}
			/>
		);
	}

	return (
		<div id="homeContainer">
			{notification ? (
				<ToastNotification
					lowContrast={false}
					className="appNotification slide-in-top"
					title={notificationContent.title}
					kind={notificationContent.type}
					caption={notificationContent.caption}
				/>
			) : null}

			<h3 id="mainTitle">Quote Creator</h3>

			<div id="actionBtnsContainer">
				<div id="leftActionBtns">
					<Button id="addInventoryBtn" onClick={() => _handleAddMoreInventory()} renderIcon={Add32}>
						Add Inventory Item
					</Button>

					<Button id="addFlipItemBtn" onClick={() => setAddFlipItemOpen(true)} renderIcon={RotateClockwise20}>
						Add Flip Item
					</Button>

					{/* manage add flip item modal */}

					<Modal
						id="quickAddFlipItem"
						aria-label={'Add flip item modal'}
						open={addFlipItemOpen}
						onRequestClose={(e) => _handleCloseModalOnlyOnCancelBtn(e, setAddFlipItemOpen)}
						size={'sm'}
						hasScrollingContent={true}
						primaryButtonText={'Add Flip Item'}
						secondaryButtonText={'Cancel'}
						onRequestSubmit={() => _handleSubmitFlipItems()}
					>
						<div id="flipItemModalCont">
							<TextInput
								id="case-code-field"
								labelText="Item Number"
								value={`FLIP${currentQuote.length + 1}`}
								disabled
								style={{ marginBottom: '1rem' }}
							/>
							<TextInput
								id="upc-field"
								labelText="UPC"
								placeholder="037000816225"
								style={{ marginBottom: '1rem' }}
								onChange={(e) => setNewFlip({ ...newFlip, upc: e.target.value })}
							/>
							<TextInput
								id="description-field"
								labelText="Description"
								placeholder="CASC GEL ADV PWR FRESH 4/125OZ"
								style={{ marginBottom: '1rem' }}
								onChange={(e) => setNewFlip({ ...newFlip, description: e.target.value })}
							/>
							<TextInput
								id="pd-field"
								labelText="Status"
								placeholder="W  "
								style={{ marginBottom: '1rem' }}
								onChange={(e) => setNewFlip({ ...newFlip, paidFor: e.target.value })}
							/>
							<TextInput
								id="units-field"
								labelText="Units"
								placeholder="2000"
								style={{ marginBottom: '1rem' }}
								onChange={(e) => setNewFlip({ ...newFlip, units: e.target.value })}
							/>
							<TextInput
								id="pksize-field"
								labelText="Packet Size"
								placeholder="2000"
								style={{ marginBottom: '1rem' }}
								onChange={(e) => setNewFlip({ ...newFlip, packSize: e.target.value })}
							/>
							<TextInput
								id="price-field"
								labelText="Price"
								placeholder="13.99"
								style={{ marginBottom: '1rem' }}
								onChange={(e) => setNewFlip({ ...newFlip, listPrice: e.target.value })}
							/>

							<DatePicker
								style={{ marginBottom: '1rem' }}
								datePickerType="single"
								onChange={(e) => setNewFlip({ ...newFlip, expireDate: displayDate(e) })}
							>
								<DatePickerInput placeholder="mm/dd/yyyy" labelText="Expiration Date" id="est-expiration-date-field" />
							</DatePicker>

							<DatePicker
								style={{ marginBottom: '1rem' }}
								datePickerType="single"
								onChange={(e) => setNewFlip({ ...newFlip, estimatedShipDate: displayDate(e) })}
							>
								<DatePickerInput placeholder="mm/dd/yyyy" labelText="Estimated Shipping Date" id="est-ship-date-field" />
							</DatePicker>
						</div>
					</Modal>

					{/* manage edit modal */}

					<Modal
						id="quickEditItem"
						aria-label={'Edit item modal'}
						open={editItemOpen}
						onRequestClose={(e) => _handleCloseModalOnlyOnCancelBtn(e, setEditItemOpen)}
						size={'xs'}
						hasScrollingContent={true}
						primaryButtonText={'Edit Item'}
						secondaryButtonText={'Cancel'}
						onRequestSubmit={() => _handleEditItem()}
					>
						<TextInput
							id="case-code-field-edititem"
							labelText="Case Code"
							value={itemEdit.itemNumber ? itemEdit.itemNumber : ''}
							style={{ marginBottom: '1rem' }}
							onChange={(e) => setItemEdit({ ...itemEdit, itemNumber: e.target.value })}
						/>
						<TextInput
							id="upc-field-edititem"
							labelText="UPC"
							placeholder="037000816225"
							style={{ marginBottom: '1rem' }}
							value={itemEdit.upc ? itemEdit.upc : ''}
							onChange={(e) => setItemEdit({ ...itemEdit, upc: e.target.value.replace(/ /g, '') })}
						/>
						<TextInput
							id="description-field-edititem"
							labelText="Description"
							placeholder="CASC GEL ADV PWR FRESH 4/125OZ"
							style={{ marginBottom: '1rem' }}
							value={itemEdit.description ? itemEdit.description : ''}
							onChange={(e) => setItemEdit({ ...itemEdit, description: e.target.value })}
						/>

						<DatePicker
							style={{ marginBottom: '1rem' }}
							datePickerType="single"
							onChange={(e) => setItemEdit({ ...itemEdit, expireDate: displayDate(e) })}
							value={itemEdit.expireDate ? itemEdit.expireDate : ''}
						>
							<DatePickerInput placeholder="mm/dd/yyyy" labelText="Expiration Date" id="expiration-date-field-edititem" />
						</DatePicker>

						<DatePicker
							style={{ marginBottom: '1rem' }}
							datePickerType="single"
							onChange={(e) => setItemEdit({ ...itemEdit, estimatedShipDate: displayDate(e) })}
							value={itemEdit.estimatedShipDate ? itemEdit.estimatedShipDate : ''}
						>
							<DatePickerInput placeholder="mm/dd/yyyy" labelText="Estimated Shipping Date" id="est-ship-date-field-edititem" />
						</DatePicker>
						<TextInput
							id="pd-field-edititem"
							labelText="PD"
							placeholder="Y"
							style={{ marginBottom: '1rem' }}
							value={itemEdit.paidFor ? itemEdit.paidFor : ''}
							onChange={(e) => setItemEdit({ ...itemEdit, paidFor: e.target.value })}
						/>
						<TextInput
							id="units-field-edititem"
							labelText="Units"
							placeholder="2000"
							style={{ marginBottom: '1rem' }}
							value={itemEdit.units ? itemEdit.units : ''}
							onChange={(e) => setItemEdit({ ...itemEdit, units: e.target.value })}
						/>
						<TextInput
							id="pksize-field-edititem"
							labelText="Packet Size"
							placeholder="2000"
							style={{ marginBottom: '1rem' }}
							value={itemEdit.packSize ? itemEdit.packSize : ''}
							onChange={(e) => setItemEdit({ ...itemEdit, packSize: e.target.value })}
						/>
						<TextInput
							id="price-field-edititem"
							labelText="Price (USD)"
							placeholder="13.99"
							style={{ marginBottom: '1rem' }}
							value={itemEdit.listPrice ? itemEdit.listPrice : ''}
							onChange={(e) => setItemEdit({ ...itemEdit, listPrice: e.target.value })}
						/>
					</Modal>

					{/* manage Images modal */}

					<Modal
						id="AddImagesItem"
						aria-label={"Manages item's images modal"}
						open={imagesModalOpen}
						onRequestClose={(e) => _handleCloseModalOnlyOnCancelBtn(e, setImagesModalOpen)}
						size={'sm'}
						hasScrollingContent={true}
						primaryButtonText={'Done'}
						secondaryButtonText={'Cancel'}
						onRequestSubmit={() => setImagesModalOpen(false)}
						passiveModal={true}
					>
						{renderImgModalContent()}
					</Modal>

					{/* crop images modal */}
					<Modal
						id="cropImageModal"
						aria-label={'Crop Image modal'}
						open={cropModalOpen}
						onRequestClose={(e) => setCropModalOpen(false)}
						hasScrollingContent={true}
						primaryButtonText={'Save Image'}
						secondaryButtonText={'Cancel'}
						onRequestSubmit={showCroppedImage}
					>
						<div id="globalCropContainer">
							<div className={'cropContainer'}>
								<Cropper
									labelText={'Change Zoom'}
									image={imageToCrop}
									crop={crop}
									rotation={rotation}
									zoom={zoom}
									aspect={1 / 1}
									onCropChange={setCrop}
									onRotationChange={setRotation}
									onCropComplete={onCropComplete}
									onZoomChange={setZoom}
								/>
							</div>
							<div id="slidersContainer">
								<div className="theSliders" id="zoomSlidercontainer">
									<Slider
										name="Zoom slider"
										id="theZoomSlider"
										inputType="number"
										labelText="Zoom"
										ariaLabelInput="Zoom Slider"
										min={1}
										minLabel={''}
										max={3}
										maxLabel={''}
										onChange={(e) => setZoom(e.value)}
										step={0.1}
										value={zoom}
										hideTextInput={true}
									/>
								</div>
								<div className="theSliders" id="rotationSliderContainer">
									<Slider
										name="Zoom slider"
										id="theZoomSlider"
										inputType="number"
										labelText="Rotation"
										ariaLabelInput="Zoom Slider"
										min={0}
										minLabel={''}
										max={360}
										maxLabel={''}
										onChange={(e) => setRotation(e.value)}
										step={1}
										value={rotation}
										hideTextInput={true}
									/>
								</div>
							</div>
						</div>
					</Modal>
				</div>
				<div id="rightActionBtns">
					<Button onClick={() => _handleSettingStep2(1)} renderIcon={ArrowRight20}>
						Next
					</Button>
				</div>
			</div>

			<div id="quoteItemsTableContainer">
				<Table>
					<TableHead>
						<TableRow>
							{headers.map((header) => (
								<TableHeader key={header.key}>{header.header}</TableHeader>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{currentQuote.map((row, quoteItemIndex) => {
							row.actions = true;
							return (
								<TableRow key={quoteItemIndex}>
									{Object.keys(row)
										.filter((key) => key !== 'id')
										.map((key, i) => {
											// console.log("MAPPING >", key); //// DEBUG:
											// console.log("OF", row);
											const headersLabels = headers.map((header) => header.key);

											if (headersLabels.indexOf(key) < 0) {
												return;
											}

											if (key === 'thumbnails') {
												return (
													<TableCell key={key}>
														<div id="thumbCellContainer">
															<a href="#">
																<Zoom zoomMargin={40}>
																	<Img
																		key={i}
																		src={[
																			`https://cwc-product-images-s3-bucket.s3.amazonaws.com/product_images/${row.upc}.jpg`,
																			`https://cwc-product-images-s3-bucket.s3.amazonaws.com/product_images/${row.upc}.png`,
																			`https://cwc-product-images-s3-bucket.s3.amazonaws.com/product_images/${row.upc}`,
																			`https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?format=jpg&quality=90&v=1530129081`,
																		]}
																		width={35}
																	/>
																</Zoom>
															</a>
														</div>
													</TableCell>
												);
											}

											if (key === 'actions') {
												let actionIcon = (
													<TableCell key="actionsDropdown" className="bx--table-column-menu">
														<OverflowMenu flipped>
															<OverflowMenuItem
																onClick={() => _handleMoveUpItem(quoteItemIndex)}
																itemText="Line Up"
															></OverflowMenuItem>
															<OverflowMenuItem
																onClick={() => _handleMoveDownItem(quoteItemIndex)}
																itemText="Line Down"
															></OverflowMenuItem>
															<OverflowMenuItem
																onClick={() => _handleOpenEditModal(quoteItemIndex)}
																itemText="Modify Item"
															></OverflowMenuItem>
															<OverflowMenuItem
																onClick={() => _handleOpenImagesModal(quoteItemIndex)}
																itemText="Manage Images"
															></OverflowMenuItem>
															<OverflowMenuItem
																onClick={() => _handleDeleteQuoteItem(quoteItemIndex)}
																isDelete
																itemText="Delete Item"
															></OverflowMenuItem>
														</OverflowMenu>
													</TableCell>
												);
												return actionIcon;
											}

											if (key === 'estimatedShipDate') {
												return <TableCell key={key}>{displayDate(row[key])}</TableCell>;
											}

											if (key === 'expireDate') {
												return <TableCell key={key}>{row[key] === '' || !row[key] ? 'N/A' : displayDate(row[key])}</TableCell>;
											}

											if (key === 'deleted') {
												return;
											}

											return <TableCell key={key}>{row[key]}</TableCell>;
										})}
								</TableRow>
							);
						})}
					</TableBody>
				</Table>
			</div>
		</div>
	);
}

export default QuoteCreator;
